/**
 * De drempels van de meetmoment-signalering, op één plek.
 *
 * Ze bepalen wanneer een openstaand meetmoment een oordeel krijgt. Houd ze
 * hier: een getal dat ook in een component staat, drijft binnen een maand uit
 * elkaar.
 */

/**
 * Zoveel eigen waarnemingen moet een onderzoek hebben voordat we durven te
 * zeggen dat iets "te laat" is.
 *
 * Waarom niet één vaste termijn voor iedereen: op de live gegevens (2026-08-27)
 * lopen de waargenomen tussentijden van gekoppelde onderzoeken van 9 tot 231
 * dagen. Eén standaardwaarde zou bij vrijwel iedereen fout zijn, en een
 * verkeerd "te laat" is schadelijker dan geen oordeel — het kleurt mensen rood
 * die niets mankeren, en daarna kijkt niemand er meer naar.
 */
const MIN_OBSERVATIONS_FOR_VERDICT = 3

/**
 * Een afgeleide tussentijd onder deze grens levert geen oordeel op. Een
 * onderzoek waarin voor- en nameting op dezelfde dag worden ingevuld heeft geen
 * wachttijd; dan is niemand ooit te laat, en dat hoort ook zo.
 */
const MIN_INTERVAL_DAYS = 1

/** Vanaf dit veelvoud van de gebruikelijke tussentijd heet iets "te laat". */
const OVERDUE_FACTOR = 1.25

/** Vanaf dit veelvoud heet iets "binnenkort aan de beurt". */
const DUE_SOON_FACTOR = 0.75

/**
 * Hoeveel dagen vóór het bestaan van een meetmoment iemand nog mag zijn
 * begonnen en toch een nulmeting kan doen.
 *
 * Een nulmeting meet de beginsituatie; die kan alleen aan het begin van een
 * traject. Wie al maanden of jaren meedraaide toen het meetmoment werd
 * aangemaakt, kan hem niet meer inhalen — dat is geen achterstand maar een
 * gepasseerd station. Een kleine marge blijft: wie net begon toen het onderzoek
 * werd ingericht, kan prima nog een nulmeting invullen.
 */
const BASELINE_GRACE_DAYS = 30

/**
 * Bij een huishouden is de laatste meting een vast aantal dagen na de
 * afronding van het traject aan de beurt: zes weken. Dit is een afspraak
 * (Gijs, 2026-09-11), geen afgeleide waarde — de maatregelen hebben die tijd
 * nodig om effect te hebben. Zolang het traject loopt is er geen datum.
 *
 * Deelnemers kennen deze regel niet; daar blijft de tussentijd afgeleid uit de
 * eigen waarnemingen van het onderzoek.
 */
const HOUSEHOLD_FOLLOW_UP_DAYS = 42

/** Zoveel dagen vóór die datum heet het bij een huishouden 'bijna zover'. */
const HOUSEHOLD_DUE_SOON_DAYS = 7

export {
    MIN_OBSERVATIONS_FOR_VERDICT,
    BASELINE_GRACE_DAYS,
    MIN_INTERVAL_DAYS,
    OVERDUE_FACTOR,
    DUE_SOON_FACTOR,
    HOUSEHOLD_FOLLOW_UP_DAYS,
    HOUSEHOLD_DUE_SOON_DAYS,
}
